import { render, staticRenderFns } from "./EventNavigationDropDownMenu.vue?vue&type=template&id=36160b05&scoped=true&"
import script from "./EventNavigationDropDownMenu.vue?vue&type=script&lang=js&"
export * from "./EventNavigationDropDownMenu.vue?vue&type=script&lang=js&"
import style0 from "./EventNavigationDropDownMenu.vue?vue&type=style&index=0&id=36160b05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36160b05",
  null
  
)

export default component.exports